import { createRoute } from '@tanstack/react-router';

import { useMaterialSearchStore } from '$/components/core/Collection/MaterialSearch/store/useMaterialSearchStore';
import { CollectionCategoryPage } from '$/pages/DashboardPages/pages/Collection/pages/CollectionCategoryPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const WallsCollectionRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/collections/walls',
  component: () => <CollectionCategoryPage materialType='wall_texture' />,
  loader: () => {
    useCollectionStore.setState({
      activeType: 'wall_texture',
      selectedViewMode: 'grid',
    });
    useMaterialSearchStore.setState({
      dropdownVisible: false,
    });
  },
  onLeave: () => {
    useCollectionStore.getState().resetAppliedFilter();
  },
  staleTime: 0,
});
